import React from 'react';

import { CheckboxCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import PropTypes from 'prop-types';

import { formsTestIds } from '../../../forms.testIds';

const DynamicFieldBoldCheckbox = ({ value, onChange, isHidden = false }) => (
  <CheckboxCDS
    fullWidth
    dataTestId={formsTestIds.STYLE_VIEW_BOLD_CHECKBOX}
    isHidden={isHidden}
    label="Bold"
    name="isBold"
    value={value}
    onChange={onChange}
  />
);

DynamicFieldBoldCheckbox.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  isHidden: PropTypes.bool,
};

export default DynamicFieldBoldCheckbox;
